import posthog from "posthog-js";

let initialized = false;

type PostHogOptions = {
  release?: string;
  environment?: string;
};

export function initPostHog(apiKey: string, apiHost: string, opts?: PostHogOptions) {
  if (typeof window === "undefined") return null;
  if (initialized) return posthog;
  if (!apiKey) return null;

  posthog.init(apiKey, {
    api_host: apiHost,
    capture_pageview: false,
    autocapture: true,
    capture_exceptions: true,
    persistence: "localStorage+cookie",
    respect_dnt: true,
    session_recording: {
      maskAllInputs: false,
      maskInputFn: (text, element) => {
        const type = element?.getAttribute("type");
        if (type === "password" || type === "hidden") return "*".repeat(text.length);
        return text;
      },
    },
  });

  if (opts?.release) posthog.register({ $release: opts.release });
  if (opts?.environment) posthog.register({ $environment: opts.environment });

  initialized = true;
  return posthog;
}

export function getPostHog() {
  if (!initialized) return null;
  return posthog;
}
